import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginScreen } from "../../routes/LoginScreen";
import { SecurityDisclosure } from "../../routes/SecurityDisclosure";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { BrowserObservabilityClient } from "../../observability/clients";
import { createStartupRuntimeContext } from "../runtimeContext";

const ProtectedApp = lazy(() =>
  import("../../routes/ProtectedApp").then((module) => ({
    default: module.ProtectedApp,
  })),
);

export function AppRoutes() {
  return (
    <ErrorBoundary
      observability={
        new BrowserObservabilityClient(
          createStartupRuntimeContext("production"),
        )
      }
      boundary="route"
    >
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/security" element={<SecurityDisclosure />} />
          <Route path="/*" element={<ProtectedApp />} />
          <Route path="*" element={<Navigate to="/command-center" replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
